import axiosInstance from "../../../utils/axios";
import { ROLE, TRANSACTION_PRINT_TYPES } from "../../../utils/Constants";

const path = "cashier/sales";
const options = {role: ROLE.CASHIER};

export const todaySales = async (values) => {
    return await axiosInstance(options).get(`${path}/today-sales`, values);
}
  
export const transactionHistory = async (values) => {
  return await axiosInstance(options).post(`${path}/transaction-history`, values);
}

export const SalesHistoryData = async (values) => {
  return await axiosInstance(options).post(`${path}/sales-history`, values);
}

export const transactionDetail = async (values) => {
  return await axiosInstance(options).get(`${path}/transaction-detail?o_id=${values.o_id}&printReceipt=${values.printReceipt}&type=${values.type || TRANSACTION_PRINT_TYPES.RECEIPT}`, values);
}


export const deleteTransactionSlip = async (values) => {
  return await axiosInstance(options).put(`${path}/transaction-slip-delete`,values );
}

export const editSalesSlipCashier = async (values) => {
  // A 401 here means the entered per-action password was wrong, not that the
  // active cashier's session expired — don't force-logout on it.
  const cashierOptions = {role: ROLE.CASHIER,'active-user-email':values.email,'active-user-password':values.password, suppressUnauthorizedHandling: true};
  return await axiosInstance(cashierOptions).post(`${path}/edit-slip`, values);
}
